<script>
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "TabelViolation",

  components: { Datatable, Pagination },

  props: {
    idjadwal: { type: [String, Number], required: true },
    idjadwalBatch: { type: [String, Number], required: true },
    idjadwalPeserta: { type: [String, Number], required: true },
    selectedKompetensi: { default: null },
  },

  data() {
    let sortOrders = [];
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "Violation", name: "violation" },
      { width: "auto", label: "Occurred", name: "occurred_at" },
      { width: "auto", label: "Recorded", name: "recorded_at" },
      { width: "auto", label: "Evidence", name: "evidence_url" },
    ];
    columns.forEach((col) => { sortOrders[col.name] = -1; });

    return {
      loadingTable: true,
      table_data: [],
      columns,
      sortOrders,
      sortKey: "recorded_at",
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "idproctoring_evidence",
        dir: "asc",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },

  watch: {
    idjadwal(val) {
      if (val) {
        this.tableFilter.page = 1;
        this.getData();
      }
    },
    selectedKompetensi() {
      if (this.idjadwal) {
        this.tableFilter.page = 1;
        this.getData();
      }
    },
  },

  mounted() {
    if (this.idjadwal) {
      this.getData();
    }
  },

  methods: {
    async getData() {
      this.loadingTable = true;
      try {
        const response = await axios({
          url: process.env.VUE_APP_BACKEND_URL_VERSION + "report-proctor-peserta/detail",
          method: "get",
          params: {
            idjadwal: this.idjadwal,
            idjadwal_batch: this.idjadwalBatch,
            idjadwal_peserta: this.idjadwalPeserta,
            idkompetensi: this.selectedKompetensi,
            page: this.tableFilter.page,
            per_page: this.tableFilter.per_page,
            search: this.tableFilter.search,
            sort_field: this.sortKey,
            sort_order: this.sortOrders[this.sortKey] === 1 ? "asc" : "desc",
          },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        const res = response.data.data;
        this.table_data = res.data;
        this.configPagination(res);
        this.currentTablePage = res.current_page;
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Peringatan",
          text: "Terjadi kesalahan pada sistem",
        });
      } finally {
        this.loadingTable = false;
      }
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getData();
    },

    toPage(url) {
      const link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getData();
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },

    formatViolation(label) {
      const map = {
        "tab-return": "Switched to different application",
        "aux-video-uploaded": "Auxiliary video uploaded",
      };
      return map[label] || label;
    },

    formatDateTime(datetime) {
      if (!datetime) return "-";
      const date = new Date(datetime);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    },

    openImage(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <datatable
        :columns="columns"
        :sortKey="sortKey"
        :sortOrders="sortOrders"
        @sort="sortBy"
      >
        <tbody>
          <tr v-if="loadingTable">
            <td colspan="99" class="text-center">
              <i class="fas fa-spinner fa-spin"></i> Loading...
            </td>
          </tr>

          <tr v-else-if="!table_data || table_data.length === 0">
            <td colspan="99" class="text-center">Data Tidak Tersedia</td>
          </tr>

          <tr
            v-else
            v-for="(row, key_data) in table_data"
            :key="row.idproctoring_evidence"
          >
            <td class="text-center">
              {{ (currentTablePage - 1) * (tableFilter.per_page || 10) + key_data + 1 }}
            </td>

            <td>{{ formatViolation(row.label) }}</td>

            <td class="text-center">{{ formatDateTime(row.occurred_at) }}</td>

            <td class="text-center">{{ formatDateTime(row.recorded_at) }}</td>

            <td class="text-center">
              <audio
                v-if="row.label === 'noise-detected' && row.evidence_url"
                :src="row.evidence_url"
                controls
                style="width: 120px;"
              ></audio>

              <img
                v-else-if="row.evidence_url"
                :src="row.evidence_url"
                width="80"
                style="cursor: pointer;"
                @click="openImage(row.evidence_url)"
              />

              <span v-else>-</span>
            </td>
          </tr>
        </tbody>
      </datatable>
    </div>
    <pagination :pagination="pagination" @to-page="toPage"></pagination>
  </div>
</template>
